import styled from 'styled-components';
import { Alert, Card, Form, Table, Tabs, Tag } from 'antd';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #e5e5e5;
`;

export const PageHeader = styled.div`
  background: #ffffff;
  font-size: 16px;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  color: #31394d;
  height: 70px;
  font-weight: 500;
  padding: 0 24px;
`;

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px;
  padding: 24px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.252406);
  flex: 1 1 0px;
`;

export const PageContentHeader = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #335777;
  margin-bottom: 24px;
`;

export const PageContentTabs = styled(Tabs)`
  .ant-tabs-tab {
    padding: 0 8px 4px;
    .ant-tabs-tab-btn {
      color: #335777;
    }
  }
  .ant-tabs-ink-bar {
    background: #335777;
  }
`;

export const SelectedAlertsHeader = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: #335777;
`;

export const SelectedAlertContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  padding: 1px 0px;
  font-size: 12px;
  font-weight: 400;
  color: #748aa1;
`;

export const StyledTable = styled(Table)`
  .ant-table {
    font-size: 10px;
  }

  .ant-table-cell {
    padding: 10px 10px;
    color: #556069;
  }

  .ant-table-thead > tr > th {
    background: #eef4fa;
    color: #556069;
  }

  .pc25-column {
    width: 25%;
  }

  .ant-table-selection-column {
    padding: 0;
    min-width: 0px;
  }

  .ant-table-selection {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }

  .ant-table-selection-column,
  .ant-table-selection {
    .ant-checkbox-wrapper {
      position: absolute;
      top: 6px;
      left: 8px;
      @media print {
        display: none;
      }
    }
  }

  .ant-checkbox-wrapper {
    @media print {
      display: none;
    }
    &:hover {
      .ant-checkbox-inner {
        border-color: #21b4bd;
      }
    }

    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: #21b4bd;
    }
  }

  .ant-checkbox-checked {
    &::after {
      border: 1px solid #21b4bd;
    }

    .ant-checkbox-inner {
      background-color: #21b4bd;
      border-color: #21b4bd;
    }
  }

  .ant-checkbox-indeterminate {
    .ant-checkbox-inner {
      border-color: #21b4bd;

      ::after {
        background-color: #21b4bd;
      }
    }
  }

  .ant-pagination-total-text {
    color: #b8bec5;
    flex: 1;
  }

  .ant-select-selection-item,
  .ant-select-item-option-content {
    text-transform: capitalize;
  }
`;

export const BoldedHeaderCell = styled.div`
  a,
  div:first-of-type {
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    display: block;
  }
`;

export const AbsoluteCellWithBoldHeader = styled(BoldedHeaderCell)`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  padding: 8px 8px;

  a {
    color: #0c8ed7;
  }
`;
export const CaseHeader = styled.div`
  font-weight: normal;
  margin-left: 18px;
`;

export const SecondaryHeader = styled.div`
  font-weight: normal;
`;

export const PageFooter = styled.div`
  background: #ffffff;
  font-size: 16px;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  color: #31394d;
  height: 52px;
  font-weight: 500;
  padding-right: 9px;
`;

export const EllipsisBlock = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: break-word;
  word-break: break-word;
`;

export const LeftEllipsisBlock = styled(EllipsisBlock)`
  direction: rtl;
`;

export const SelectedAlertContainerTitle = styled.span`
  color: #748aa1;
`;

export const ChartSubTitleContainer = styled.div`
  position: absolute;
`;

export const ChartSubTitleText = styled.span`
  color: #748aa1;
`;

export const ActionsContainer = styled.div`
  display: block;
  text-align: end;
`;

export const AlertActionsContainer = styled.div`
  margin-top: 25px;
`;

export const StyledTag = styled(Tag)`
  margin-bottom: 8px;
  color: #556069;
  background: #f7f7f8;
  border: 1px solid #d0d7e3;
  border-radius: 4px;
  & > .ant-tag-close-icon {
    vertical-align: baseline;
  }
`;

export const StyledFormItem = styled(Form.Item)`
  & > .ant-form-item-label {
    padding-bottom: 4px;
    height: 24px;
    & > label {
      font-size: 12px;
      line-height: 20px;
      color: #748aa1;
    }
  }
`;

export const BorderContainer = styled.div`
  min-width: 40%;
  max-width: 45%;
  padding: 15px;
  border: 1px solid #eceff4;
  border-radius: 4px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.252406);
  display: flex;
  flex-direction: column;

  @media print {
    width: 50%;
  }
`;

//Priority Modal

export const NameCard = styled(Card)`
  background-color: #f7f7f7;
  border: 1px solid #ccc;
  padding: 10px;
  margin: 10px;
  border-radius: 5px;
  font-size: 14px;

  .ant-card-body {
    padding: 4px;
  }
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 5px;
`;
export const StyledDiv = styled.div`
  list-style: none;
`;
export const Priority = styled.div`
  color: #1890ff;
  font-weight: 500;
`;
export const AutomationName = styled.div`
  color: #556069;
  font-weight: 500;
`;
export const StyledSpan = styled.span`
  font-size: 12px;
  line-height: 20px;
  color: #748aa1;
  margin-left: 11px;
`;
